import { Module } from 'vuex';
import { RoutineWorkTemplateState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: RoutineWorkTemplateState = {
    templates: undefined,
    templateCount: 0,
    index: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

export const routineWorkTemplate: Module<RoutineWorkTemplateState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
